export const projects = [
  {
    title: "React Movie Search",
    subtitle: "React",
    description:
      "An IMDB type site to search for movies. The site utilizes the omdb API",
    image: "./movie.png",
    link: "https://kdotelle.github.io/movie_database/",
  },
  {
    title: "Calculator App",
    subtitle: "React",
    description: "A responsive calculator app built using React",
    image: "./calculator.png",
    link: "https://kdotelle.github.io/ReactCalculator/",
  },
  {
    title: "Color Picker",
    subtitle: "React",
    description:
      "A responsive app that allows users to view and create custom color palettes.",
    image: "./color-picker.png",
    link: "https://kdotelle.github.io/react-color-app/",
  },
  {
    title: "Paint Like Bob Ross",
    subtitle: "React, CSS, Bootstrap",
    description:
      "A freeform paint canvas where users have the ability to change the brush size, choose the color, and eras brush strokes. ",
    image: "./bobross.png",
    link: "https://paintlikebobross.netlify.app/",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "JavaScript",
  "React",
  ".NET/ASP.NET",
  "Entity Framework",
  "SQL",
  "REST APIs",
];



// WEBPACK FOOTER //
// ./src/data.js